import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import type {InjectIntl} from "@irati/utils/lang"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {walletTracking} from "@irati-tracking/wallet"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import authentication from "@irati/auth"
import {ButtonRouterLink} from "@irati/ui/src/Link"

interface Props extends InjectIntl {
  currency: string
}

class NoDataCTA extends PureComponent<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  handleLinkCardClick = () => {
    walletTracking.clickLinkCard()
  }

  render() {
    const idNamespace = id("no-data", this.props)
    const {apps} = this.context
    const {currency} = this.props

    if (!authentication.apps("platform.fidel")) {
      return null
    }
    return (
      <>
        {currency === "TT" && (
          <ButtonRouterLink
            full
            primary
            large
            marginTop={2}
            to="/categories/flexi-perks"
            app={apps.PERKS}
            id={id("button-browse-perks", idNamespace)}>
            <Icon icon={IconTypes.location} small marginRight={1} />
            <FormattedMessage id="wallet.noData.useTokens" />
          </ButtonRouterLink>
        )}
      </>
    )
  }
}

export default injectIntl(NoDataCTA)
